import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '~/components/Spinner';

import {
  selectError,
  selectLiveFeed,
  selectLiveFeedInfo,
  selectLiveFeedQuestions,
  selectLoading,
} from './selectors';

const mapStateToProps = (state, props) => ({
  loading: selectLoading(state, props),
  error: selectError(state, props),
  liveFeed: selectLiveFeed(state, props),
  liveFeedQuestions: selectLiveFeedQuestions(state, props),
  liveFeedInfo: selectLiveFeedInfo(state, props),
});

export default connect(mapStateToProps)(
  class liveFeed extends Component {
    static propTypes = {
      slug: PropTypes.string.isRequired,
      render: PropTypes.func.isRequired,
    };

    static defaultProps = {
      liveFeed: undefined,
    };

    render() {
      const { liveFeed, liveFeedQuestions, liveFeedInfo, render } = this.props;
      return (
        <Spinner {...this.props}>
          {liveFeed && render({ liveFeed, liveFeedQuestions, liveFeedInfo })}
        </Spinner>
      );
    }
  },
);
